import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { LayersControl, Marker, Polyline, Popup, useMap } from "react-leaflet";
import { useParams } from "react-router-dom";
import { getFlightDetails } from "../../api/flightsAPI";
import { useAuthStore } from "../../store/authStore";
import userDroneMarkerPng from "../../assets/droneMarker.png";
import { Icon } from "leaflet";
import Legend from "../../components/legends/legends";

const { Overlay } = LayersControl;
const FlightDetailsMapView = () => {
    const map = useMap()
    const polyref = useRef(null)
    const limeOptions = { color: 'red' }

    const { flightId } = useParams();
    const { token, setLoaderState } = useAuthStore((state) => state)
    const [droneName, setDroneName] = useState("");
    const [missionWaypoints, setMissionWaypoints] = useState([]);
    const { data, isLoading } = useQuery([token, flightId], () => getFlightDetails(flightId, token), { enabled: false })

    useEffect(() => {
        if (data?.data?.data) {
            const missionPoint = data?.data?.data[0]?.missionId?.waypoints.map((mission) => [mission.lat, mission.lng])
            setMissionWaypoints(missionPoint)
            setDroneName(data?.data?.data[0]?.droneId?.droneName)
        }
    }, [data])

    useEffect(() => {
        if (isLoading) {
            setLoaderState(true)
        } else {
            setLoaderState(false)
        }
    }, [isLoading])

    useEffect(() => {
        const polyline = polyref.current;
        if (Object.keys(polyline?.getBounds()).length > 0) {
            map.fitBounds(polyline.getBounds());
        }
    }, [missionWaypoints])

    const legendData = [
        {
            title: "User Drone",
            img: userDroneMarkerPng,
        },
        {
            title: "Starting Position",
            img: "https://icon-library.com/images/map-marker-icon/map-marker-icon-18.jpg"
        },
        {
            title: "Ending Position",
            img: "https://icon-library.com/images/icon-markers/icon-markers-4.jpg"
        },
        {
            title: "Way Point",
            img: "https://icon-library.com/images/google-map-marker-icon/google-map-marker-icon-9.jpg"
        }
    ];
    return (
        <>
            <Overlay checked name="Overlay Layer">
                <>
                    {missionWaypoints && missionWaypoints?.length > 0 ? <Marker
                        position={missionWaypoints[0]}
                        icon={
                            new Icon({
                                iconUrl: userDroneMarkerPng,
                                iconSize: [30, 30],
                                iconAnchor: [25, 25],
                            })
                        }
                    >
                        <Popup>
                            <span className="font-extrabold">{droneName}</span>
                            <br />
                            <span>{missionWaypoints[0]}</span>
                        </Popup>
                    </Marker> : ""}


                    <Polyline ref={polyref} pathOptions={limeOptions} positions={missionWaypoints && missionWaypoints || []}>
                        {missionWaypoints && missionWaypoints?.map((pos, index) => {
                            return index === 0 ? (
                                <Marker eventHandlers={{
                                    mouseover: (event) => event.target.openPopup(),
                                    mouseout: (event) => event.target.closePopup(),
                                }} key={index} position={missionWaypoints && missionWaypoints[0]} icon={new Icon({
                                    iconUrl: "https://icon-library.com/images/map-marker-icon/map-marker-icon-18.jpg", iconSize: [30, 30]
                                })}>
                                    <Popup>
                                        <div className="font-extrabold">Starting Position</div>
                                        <div>{pos[0]},{pos[1]}</div>
                                    </Popup>
                                </Marker>
                            ) : index === missionWaypoints?.length - 1 ? (
                                <Marker eventHandlers={{
                                    mouseover: (event) => event.target.openPopup(),
                                    mouseout: (event) => event.target.closePopup(),
                                }} key={index} position={missionWaypoints && missionWaypoints[missionWaypoints?.length - 1]} icon={new Icon({ iconUrl: "https://icon-library.com/images/icon-markers/icon-markers-4.jpg", iconSize: [30, 30] })}>
                                    <Popup>
                                        <div className="font-extrabold">Ending Position</div>
                                        <div>{pos[0]},{pos[1]}</div>
                                    </Popup>
                                </Marker>
                            ) : <Marker eventHandlers={{
                                mouseover: (event) => event.target.openPopup(),
                                mouseout: (event) => event.target.closePopup(),
                            }} key={index} position={pos} icon={new Icon({ iconUrl: "https://icon-library.com/images/google-map-marker-icon/google-map-marker-icon-9.jpg", iconSize: [30, 30] })}>
                                <Popup>
                                    <div className="font-extrabold">Way Point</div>
                                    <span >{pos[0]},{pos[1]}</span>
                                </Popup>
                            </Marker>;
                        })}
                    </Polyline>

                </>

                <Legend data={legendData} />
            </Overlay>
        </>
    )
}

export default FlightDetailsMapView;